module.exports = __webpack_public_path__ + "static/media/ShardMeetingRoom10.6112c9f2.jpg";